import type { SVGProps } from 'react';

export const MapIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      id="icon/maps/map_24px"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.616 2.525L17.7493 2.5C17.9827 2.5 18.166 2.68333 18.166 2.91667V15.5167C18.166 15.7083 18.041 15.8583 17.866 15.9167L13.166 17.5L8.16602 15.75L3.71602 17.475L3.58268 17.5C3.34935 17.5 3.16602 17.3167 3.16602 17.0833V4.48333C3.16602 4.29167 3.29102 4.14167 3.46602 4.08333L8.16602 2.5L13.166 4.25L17.616 2.525ZM12.3327 5.72396L8.99935 4.55729V14.274L12.3327 15.4406V5.72396ZM4.83268 5.38333L7.33268 4.54167V14.2917L4.83268 15.2583V5.38333ZM13.9993 15.4583L16.4993 14.6167V4.75L13.9993 5.71667V15.4583Z"
      fill={props.fill ?? '#696F88'}
    />
  </svg>
);

export default MapIcon;
